import { atom, useRecoilValue, useSetRecoilState, SetterOrUpdater } from 'recoil';

interface IProductDetailsValues {
  notFoundHintVisible: boolean;
}

interface ISetProductDetails {
  setNotFoundHintVisible: SetterOrUpdater<boolean>;
}

const notFoundHintVisibleState = atom<boolean>({
  key: 'notFoundHintVisible',
  default: false,
});

export const useProductDetailsValues = (): IProductDetailsValues => ({
  notFoundHintVisible: useRecoilValue(notFoundHintVisibleState),
});

export const useSetProductDetails = (): ISetProductDetails => ({
  setNotFoundHintVisible: useSetRecoilState(notFoundHintVisibleState),
});
